import { makeStyles, tokens, typographyStyles } from "@microsoft/shifts-ui-core";

export const useScheduleEditorStyles = makeStyles({
    panel: {
        // For global selectors, use a wrapper and target children in JSX
    },
    paragraphs: {
        color: tokens.colorNeutralForeground3,
        ...typographyStyles.body1
    },
    generateScheduleBtn: {
        display: "flex",
        padding: "5px 12px",
        justifyContent: "center",
        alignIems: "center",
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorCompoundBrandForeground1
    },
    panelHeaderContainer: {
        height: "60px",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0 20px 0 20px",
        justifyContent: "space-between"
    },
    panelHeaderActions: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "12px"
    },
    autoSchedulePanelHeaderTitle: {
        fontFamily: "Segoe UI",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "24px",
        color: tokens.colorNeutralForeground1
    },
    headerTitle: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px"
    },
    cancelButtonContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    generateScheduleBtnTxt: {
        color: tokens.colorNeutralForegroundOnBrand,
        ...typographyStyles.body1Strong
    },
    title: {
        ...typographyStyles.subtitle2
    },
    scheduleScopeBlock: {
    },
    shiftBlocksDescription: {
        marginBottom: "20px"
    },
    externalLinkIcon: {
        verticalAlign: "middle",
        margin: "0px 4px 0px 4px",
        color: tokens.colorBrandForegroundLink
    },
    viewScheduleLink: {
        marginTop: "12px"
    },
    scheduleUpToTime: {
        margin: "0px 0 20px 0",
        color: tokens.colorNeutralForeground3,
        ...typographyStyles.body1
    },
    infoTooltip: {
        width: "50px",
        paddingTop: "10px",
        transform: "translateX(-10px)"
    },
    cancelButton: {
        marginRight: "12px"
    },
    content: {
        paddingLeft: "0px !important"
    },
    link: {
        gap: "4px",
        color: tokens.colorBrandForegroundLink,
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    },
    panelContent: {
        // Add fullPagePanel styles here
    },
    scheduleScopeContainer: {
        marginTop: "20px",
        padding: "0 24px",
        maxWidth: "600px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: tokens.colorNeutralBackground1
    },
    scopeTitle: {
        ...typographyStyles.subtitle2,
        color: tokens.colorNeutralForeground3
    },
    blockTitle: {
        marginBottom: "2px",
        color: tokens.colorNeutralForeground1,
        fontFamily: 'var(--Typography-Font-family-Base, "Segoe UI")',
        fontSize: "var(--Typography-Subtitle-2-Font-size, 16px)",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "var(--Typography-Subtitle-2-Line-height, 22px)"
    },
    timePickerLayout: {
        display: "flex",
        flexDirection: "column"
    },
    divider: {
        margin: "20px 0 20px 0",
        width: "100%",
        padding: "5px 0 4px 0",
        backgroundColor: tokens.colorNeutralBackground1
    },
    scopeFields: {
        display: "flex",
        flexDirection: "row",
        gap: "12px"
    },
    label: {
        fontSize: "12px !important",
        color: "var(--app-gray-03) !important"
        // Add font styles as needed
    },
    scheduleField: {
        maxWidth: "141px",
        borderRadius: "4px",
        background: tokens.colorNeutralBackground3,
        padding: "4px"
    },
    groupDropdownBox: {
        borderRadius: "4px",
        width: "294px",
        background: tokens.colorNeutralBackground3
    },
    fluentProvider: {
        marginBottom: "7px",
        minWidth: "200px",
        backgroundColor: "transparent !important"
    },
    scopeFieldsChild: {
        minWidth: "180px"
    },
    shiftBlocksContainer: {
        display: "flex",
        flexDirection: "column"
    },
    choiceOptionWrapper: {
        padding: "16px",
        borderRadius: "8px",
        border: "1px solid var(--colorNeutralStroke2, #e1e1e1)",
        marginBottom: "8px",
        background: "var(--neutralLayerFloating, #fff)",
        fontSize: "14px",
        "&:focus-within, &:hover": {
            // borderColor: "var(--colorNeutralStrokeAccessible, #c8c8c8)",
            boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.02)"
        }
    },
    shiftBlocksGroupContainer: {
        display: "flex",
        flexDirection: "column",
        maxWidth: "552px"
    },
    choiceOptionDescription: {
        marginLeft: "26px",
        marginTop: "7px",
        color: "var(--neutral-foreground-secondary)",
        fontSize: "inherit"
    },
    teachingBubbleActions: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        marginTop: "16px"
    },
    generateDialogActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
        width: "100%",
        "& > button": {
            borderRadius: "4px"
        }
    },
    editorDialogBodyContent: {
        "& .fui-DialogContent": {
            marginTop: "16px",
            marginBottom: "16px"
        },
        "& .fui-Radio": {
            width: "90%",
            padding: "16px",
            borderRadius: "8px",
            border: `1px solid ${tokens.colorNeutralStroke2}`,
            marginBottom: "8px"
        },
        "& .fui-Radio .fui-Label": {
            width: "100%"
        }
    },
    addShiftButton: {
        display: "flex",
        padding: "5px 12px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: tokens.borderRadiusMedium,
        border: `1px solid ${tokens.colorBrandStroke1}`,
        background: tokens.colorNeutralBackground1,
        color: tokens.colorBrandStroke1,
        "&:hover": {
            border: `1px solid ${tokens.colorNeutralForeground2BrandHover}`,
            color: tokens.colorNeutralForeground3BrandSelected
        }
    },
    addShiftButtonText: {
        ...typographyStyles.body1Strong
    }
});
